import React, { useContext } from 'react';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';
import { useTranslation } from 'react-i18next';
import styles from '../../../src/css/components/forms/moreInfoLink.css';

function MoreInfoLink() {
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const { t } = useTranslation('translation');

	const getGameMasterPageUrl = (marketId, gameUrl) => `https://${marketId}0.${gameUrl}/page/`;

	return (
		<a
			href={getGameMasterPageUrl(onelpsParams.marketId, onelpsParams.gameUrl)}
			target="_blank"
			rel="noopener noreferrer"
			data-testid="more-info-link"
			className={styles.moreInfoLink}
		>
			{t('oneStepForm.moreInfo')}
		</a>
	);
}

export default MoreInfoLink;
